import type { CardArtFamily } from '../../lib/cardArt';

/**
 * Mystic Noir — antique gold strokes on deep indigo.
 * Art-deco / occultist symbol language. No figurative imagery.
 */
export default function MysticCardArt({ family }: { family: CardArtFamily }) {
  const stroke = { stroke: '#c9a24a', strokeWidth: 0.6, fill: 'none', opacity: 0.9 };
  const filled = { fill: '#c9a24a', opacity: 0.85 };

  switch (family) {
    case 'tower':
      return (
        <svg viewBox="0 0 44 58" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <rect x="16" y="10" width="12" height="42" {...stroke} />
          <polygon points="16,10 28,10 22,4" {...stroke} />
          <rect x="18" y="18" width="3" height="4" {...filled} />
          <rect x="23" y="18" width="3" height="4" {...filled} />
          <rect x="18" y="28" width="3" height="4" {...filled} />
          <rect x="23" y="28" width="3" height="4" {...filled} />
          <polyline points="36,6 30,20 34,20 28,38" {...stroke} strokeWidth={1} />
        </svg>
      );
    case 'hermit':
      return (
        <svg viewBox="0 0 44 58" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <path d="M22 6 L34 22 L30 50 L14 50 L10 22 Z" {...stroke} />
          <line x1="10" y1="22" x2="34" y2="22" {...stroke} />
          <circle cx="22" cy="34" r="6" {...stroke} />
          <polygon
            points="22,29 23.5,33 27.5,33 24.5,35.5 25.5,39.5 22,37 18.5,39.5 19.5,35.5 16.5,33 20.5,33"
            {...filled}
          />
          <line x1="22" y1="6" x2="22" y2="2" {...stroke} />
        </svg>
      );
    case 'star':
      return (
        <svg viewBox="0 0 44 58" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <g transform="translate(22 24)">
            <polygon
              points="0,-14 3,-3 14,0 3,3 0,14 -3,3 -14,0 -3,-3"
              {...filled}
            />
            <polygon
              points="0,-20 1.5,-1.5 20,0 1.5,1.5 0,20 -1.5,1.5 -20,0 -1.5,-1.5"
              {...stroke}
            />
          </g>
          <path d="M6 40 Q 14 36, 22 40 T 38 40" {...stroke} />
          <path d="M6 46 Q 14 42, 22 46 T 38 46" {...stroke} />
          <path d="M6 52 Q 14 48, 22 52 T 38 52" {...stroke} />
        </svg>
      );
    case 'wheel':
      return (
        <svg viewBox="0 0 44 58" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <g transform="translate(22 29)">
            <circle r="18" {...stroke} />
            <circle r="12" {...stroke} />
            <circle r="3" {...filled} />
            {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => (
              <line
                key={a}
                x1="0"
                y1="0"
                x2="0"
                y2="-18"
                transform={`rotate(${a})`}
                {...stroke}
                strokeWidth={0.4}
              />
            ))}
          </g>
        </svg>
      );
    case 'figure':
      return (
        <svg viewBox="0 0 44 58" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <circle cx="22" cy="16" r="6" {...stroke} />
          <path d="M14 50 L14 30 Q 22 24 30 30 L30 50 Z" {...stroke} />
          <line x1="22" y1="22" x2="22" y2="38" {...stroke} strokeWidth={0.4} />
          <circle cx="22" cy="16" r="2" {...filled} />
        </svg>
      );
    default:
      return (
        <svg viewBox="0 0 44 58" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <circle cx="22" cy="28" r="14" {...stroke} />
          <circle cx="22" cy="28" r="2" {...filled} />
        </svg>
      );
  }
}
